import EnergySavingsLeafIcon from '@mui/icons-material/EnergySavingsLeaf';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function EcoIcon(props: FixMe) {
  return <EnergySavingsLeafIcon {...props} />;
}

export default EcoIcon;
